export const favoriteProducts = ({ favorites }) => favorites?.products;
export const favoriteProductsData = ({ favorites }) => ({
    variantIds: favorites?.variantIds ?? [],
    requestQueue: favorites?.requestQueue ?? []
});
